import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash, faUser} from "@fortawesome/free-solid-svg-icons";
import { FrontEndRoutes } from "../../config/front-end-routes";
import { BackEndRoutes } from "../../config/back-end-routes";
import { api } from "../../config/api";
import { toast } from "react-toastify";
import AppFooter from "../../Components/Footer/Footer";
import NavigationBar from "../../Components/Navbar";
import Breadcrumb from "../../Components/BreadCrumb";

const Login: React.FC = () => {
    const [email, setEmail] = useState(""); // Email ou nome de usuário
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const handleLogin = (e: React.FormEvent) => {
        e.preventDefault();

        if (!email || !password) {
            toast.error("Por favor, preencha todos os campos.");
            return;
        }

        const loginData = {
            email,
            password,
        };

        setLoading(true);

        localStorage.removeItem("config");
        localStorage.removeItem("type_user_id");
        localStorage.removeItem("user");

        api.post(BackEndRoutes.routes.LOGIN, loginData)
            .then((response) => {
                if (response?.status === 200) {
                    const token = response?.data?.data?.apiToken;
                    toast.success("Login realizado com sucesso!");
                    console.log(response, 'response aqui');

                    if (token) {
                        localStorage.setItem("authToken", token);
                        //toast.success("Login realizado com sucesso!");
                        navigate(FrontEndRoutes.HOME, { replace: true });


                        // Reload em dispositivos que não são iOS
                        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window;
                        if (!isIOS) {
                            window.location.reload();
                        }
                    } else {
                        throw new Error("Token não encontrado na resposta.");
                    }
                }
            })
            .catch((error) => {
                console.error("Erro no login:", error);
                toast.error(
                    error?.response?.data?.message ||
                    "Erro ao entrar. Verifique suas credenciais e tente novamente."
                );

                if (error.response?.data?.errors) {
                    Object.values(error.response.data.errors).flat().forEach((msg: any) => toast.error(msg));
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className="d-flex flex-column vh-100" style={{background: '#ddd'}}>
            <main className="container-fluid flex-grow-1 d-flex flex-column justify-content-center">
                <div className="d-flex justify-content-center align-items-center" >

                    <div className="card shadow-lg m-3" style={{width: "400px"}}>
                        <div className="card-header bg-primary">
                            <h3 className="text-center text-white">
                                <FontAwesomeIcon icon={faUser}/> CappellusWeb
                            </h3>
                        </div>
                        <div className="card-body " style={{background: '#f8fafc'}}>
                            <form onSubmit={handleLogin} className="mt-4">
                                <div className="mb-3">
                                    <label htmlFor="identifier" className="form-label">E-mail ou Nome de Usuário</label>
                                    <input
                                        type="text"
                                        id="identifier"
                                        className="form-control"
                                        placeholder="Digite seu e-mail ou nome de usuário"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="password" className="form-label">Senha</label>
                                    <div className="input-group">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            id="password"
                                            className="form-control"
                                            placeholder="Digite sua senha"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-secondary "
                                            onClick={togglePasswordVisibility}
                                            aria-label={showPassword ? "Esconder senha" : "Mostrar senha"}
                                        >
                                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye}/>
                                        </button>
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary w-100 mt-4" disabled={loading}>
                                    {loading ? "Carregando..." : "Entrar"}
                                </button>
                            </form>
                            <div className="row mt-3 text-center">
                                <div className="col">
                                    <a href="/forgot-password" className="text-decoration-none">Esqueceu a senha?</a>
                                </div>
                                <div className="col">
                                    <a href="/request-access" className="text-decoration-none">Solicitar acesso</a>
                                </div>
                            </div>
                        </div>
                    </div>


        </div>
            </main>
    <AppFooter/>
</div>
)
    ;
};

export default Login;
